/* Wild Honey — filter panel additions on top of Dawn's own facets (which already give collapsible groups,
   swatches when Search & Discovery sets them, the price range, active-filter chips, Clear all and the
   phone drawer):
   1. a search box inside any group with more than 10 values;
   2. Dawn's "Show more" reads "Show all N";
   3. a From–To box on any group whose values are all numbers (a measurement such as Length (in)).
      Shopify gives number filters as a list of exact values, never a range, so the box ticks every value
      inside the range and lets Dawn submit as usual.
   Dawn re-draws the panel after every filter change; a MutationObserver re-applies all three. */
(function () {
  var SEARCH_AT = 10;

  function valueOf(input) {
    var label = input.closest('label');
    var t = label && label.querySelector('.facet-checkbox__text-label, .facets__label-text, .mobile-facets__label span');
    return ((t ? t.textContent : input.value) || '').trim();
  }
  function numberOf(input) {
    var n = parseFloat(String(input.value).replace(/[^0-9.\-]/g, ''));
    return isFinite(n) ? n : NaN;
  }

  function enhance(fieldset) {
    if (fieldset.hasAttribute('data-wh-done')) return;
    var boxes = Array.prototype.slice.call(fieldset.querySelectorAll('input[type="checkbox"]'));
    if (!boxes.length) return;
    fieldset.setAttribute('data-wh-done', '');
    var legend = fieldset.querySelector('legend');
    var groupName = legend ? legend.textContent.trim() : 'this filter';
    var list = fieldset.querySelector('ul');

    // 3. a numeric group gets a From–To box
    var nums = boxes.map(numberOf);
    if (boxes.length >= 3 && nums.every(function (n) { return !isNaN(n); })) {
      var lo = Math.min.apply(null, nums), hi = Math.max.apply(null, nums);
      var box = document.createElement('div');
      box.className = 'wh-range';
      box.innerHTML = '<label>From<input type="number" step="any" inputmode="decimal" data-wh-from></label>' +
        '<label>To<input type="number" step="any" inputmode="decimal" data-wh-to></label><button type="button" data-wh-apply>Apply</button>';
      box.querySelector('[data-wh-from]').placeholder = lo;
      box.querySelector('[data-wh-to]').placeholder = hi;
      box.querySelector('[data-wh-from]').setAttribute('aria-label', groupName + ' from');
      box.querySelector('[data-wh-to]').setAttribute('aria-label', groupName + ' to');
      box.querySelector('[data-wh-apply]').addEventListener('click', function () {
        var f = parseFloat(box.querySelector('[data-wh-from]').value); if (isNaN(f)) f = -Infinity;
        var t = parseFloat(box.querySelector('[data-wh-to]').value); if (isNaN(t)) t = Infinity;
        var changed = null;
        boxes.forEach(function (b, i) { var want = nums[i] >= f && nums[i] <= t; if (b.checked !== want) { b.checked = want; changed = b; } });
        if (changed) changed.dispatchEvent(new Event('input', { bubbles: true }));
      });
      if (list) list.parentNode.insertBefore(box, list); else fieldset.appendChild(box);
    }

    // 1. search inside a long group
    if (boxes.length > SEARCH_AT && list) {
      var input = document.createElement('input');
      input.type = 'search';
      input.className = 'wh-facet-search';
      input.placeholder = 'Search ' + groupName.toLowerCase();
      input.setAttribute('aria-label', 'Search ' + groupName);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var more = fieldset.querySelector('show-more-button');
        boxes.forEach(function (b) {
          var li = b.closest('li'); if (!li) return;
          if (!q) { li.classList.remove('wh-hidden'); return; }
          var hit = valueOf(b).toLowerCase().indexOf(q) !== -1;
          li.classList.toggle('wh-hidden', !hit);
          if (hit) li.classList.remove('hidden');
        });
        if (more) more.hidden = !!q;
      });
      list.parentNode.insertBefore(input, list);
    }

    // 2. "Show all N"
    var label = fieldset.querySelector('.label-show-more');
    if (label) label.textContent = '+ Show all ' + boxes.length;
  }

  function run(root) {
    (root || document).querySelectorAll('facet-filters-form fieldset, .facets-wrap, .mobile-facets__details fieldset').forEach(enhance);
  }
  function init() {
    run();
    var target = document.getElementById('main-collection-filters') || document.querySelector('.facets-container') || document.body;
    new MutationObserver(function () { run(); }).observe(target.parentNode || document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
